(function(){
'use strict';
var scheduled=false;
function update(){
 scheduled=false;
 var host=document.getElementById('redo-chat-widget');
 var button=host&&host.shadowRoot&&host.shadowRoot.getElementById('chat-widget-button');
 if(!button)return;
 var sticky=document.querySelector('.pdp-v2-sticky.is-visible, #ph-sticky.is-on');
 var bottom=16;
 if(sticky){var r=sticky.getBoundingClientRect();if(r.bottom>0&&r.top<innerHeight)bottom=Math.max(16,innerHeight-r.top+12);}
 var holder=button.parentElement;
 var value=bottom+'px';
 if(holder.style.getPropertyValue('--widget-bottom')!==value)holder.style.setProperty('--widget-bottom',value);
 var chat=button.getBoundingClientRect();
 var overlap=Array.prototype.some.call(document.querySelectorAll('[data-pdp-v2-purchase], [data-kit-purchase], .hero-offer__body .cta-row'),function(node){var r=node.getBoundingClientRect();return r.width&&r.top<chat.bottom&&r.bottom>chat.top&&r.left<chat.right&&r.right>chat.left;});
 var visibility=overlap?'hidden':'visible';
 if(button.style.visibility!==visibility)button.style.visibility=visibility;
}
function schedule(){if(!scheduled){scheduled=true;requestAnimationFrame(update);}}
window.addEventListener('scroll',schedule,{passive:true});window.addEventListener('resize',schedule);window.addEventListener('pageshow',schedule);
var attempts=0,timer=setInterval(function(){schedule();if(++attempts>=20)clearInterval(timer);},1000);
schedule();
})();
